import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserHomeConstants } from './constants/user-home-constants';
import { UserHomeService } from './services/user-home.service';
import { UserHomeCardsAccess } from './models/userHomeCardsAccess';
import { LabelConstants } from '../../shared/constants/label-constants';
import { VersionService } from '../../shared/services/version.service';
import { Subject, forkJoin, switchMap, takeUntil } from 'rxjs';
import { DashboardSummaryWithTrainingData } from './models/user-home-dashboardSummary';

@Component({
  selector: 'app-user-home',
  templateUrl: './user-home.component.html',
  styleUrls: ['./user-home.component.scss']
})
export class UserHomeComponent implements OnInit, OnDestroy {

  topBarTitle: string = UserHomeConstants.UserHomeTopBarTitle;
  accessToUserHome = false;
  userHomeAcessErrorMessage!:string;
  userHomeCardsAccess!: UserHomeCardsAccess;
  version: string = '';
  dashboardData!: DashboardSummaryWithTrainingData;
  private readonly destroy$ = new Subject<void>();

  constructor(private userHomeService: UserHomeService, private versionService: VersionService) {
  }
  
  ngOnInit(): void {
    this.userHomeService.getUserHomeAuthentication().pipe(
      switchMap((cardsAccess) => {
        this.userHomeCardsAccess = cardsAccess;
        return forkJoin([
          this.userHomeService.getDocumentDashboardCounts(cardsAccess),
          this.userHomeService.getTrainingDashboardCounts(cardsAccess),
          this.userHomeService.getDelegateDashboardCounts(cardsAccess)
        ]);
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      next: ([docData, trainingData, delegateData]) => {
        this.dashboardData = { ...docData, ...trainingData, ...delegateData } as DashboardSummaryWithTrainingData;
        this.accessToUserHome = true;
      },
      error: (err) => {
        this.accessToUserHome = false;

        if (err.status === LabelConstants.Forbidden_StatusCode) {
          this.userHomeAcessErrorMessage = err.error.detail;
        }
      }
    });

    this.versionService.getDropNumber().pipe(takeUntil(this.destroy$)).subscribe({
      next: (dropNumber) => {
        this.version = dropNumber;
      }
    });
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

userHomeErrorMessage() : string {
    if (!this.accessToUserHome) {
      return this.userHomeAcessErrorMessage;
    }
    return UserHomeConstants.UserHome_RoleAcessPermission_Fail;
  }

}
